import { banco } from '../db/banco'
import { agoraISO } from '../db/tipos'
import { gravarLocalEEnfileirar } from '../sync/outbox'

// Spec 2026-10-06: o logo da fornecedora grava NA HORA (como o Dispensar), sem
// passar pelo Salvar das abas -- e uma imagem, nao um campo do formulario.
export async function gravarLogoDaRepresentada(id: string, logo: string | null): Promise<void> {
  const r = await banco.representadas.get(id)
  if (!r) return
  await gravarLocalEEnfileirar('representadas', { ...r, logo, atualizado_em: agoraISO() })
}
